import { render } from "./UserEditData.vue?vue&type=template&id=b2500d5c"
import script from "./UserEditData.vue?vue&type=script&lang=js"
export * from "./UserEditData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__